import { render, staticRenderFns } from "./Psd.vue?vue&type=template&id=2a041f32"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a041f32')) {
      api.createRecord('2a041f32', component.options)
    } else {
      api.reload('2a041f32', component.options)
    }
    module.hot.accept("./Psd.vue?vue&type=template&id=2a041f32", function () {
      api.rerender('2a041f32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/fileExtensions/Psd.vue"
export default component.exports